export const pastelColors = ["#FFD1DC", "#B5EAD7", "#C7CEEA", "#FFE5B4", "#E0F7FA", "#F0E6FF", "#FFFACD", "#FFCCCB", "#D4F1F9", "#C9E4DE", "#FADADD", "#B2EBF2", "#DCD0FF", "#FFDFBA", "#F8BBD0", "#C8E6C9", "#E1BEE7", "#FFF8E1", "#B3E5FC", "#FFECB3", "#FCE4EC", "#DCEDC8", "#D1C4E9", "#B2DFDB", "#FFE0B2", "#E8F5E9", "#F3E5F5", "#FFF3E0", "#BBDEFB", "#F0F4C3"]

export const serviceColor = {

}